var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62063 9.83842C5.68684 9.83842 6.66699 9.47166 7.44903 8.86347L9.98806 11.4025L10.8048 10.5858L8.26572 8.04677C8.87449 7.26415 9.24125 6.284 9.24125 5.21779C9.24125 2.6701 7.16833 0.597168 4.62063 0.597168C2.07293 0.597168 0 2.6701 0 5.21779C0 7.76549 2.07293 9.83842 4.62063 9.83842ZM4.62034 1.75233C6.53155 1.75233 8.08581 3.30659 8.08581 5.2178C8.08581 7.129 6.53155 8.68327 4.62034 8.68327C2.70914 8.68327 1.15487 7.129 1.15487 5.2178C1.15487 3.30659 2.70914 1.75233 4.62034 1.75233Z",
    fill: "#A5A5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43606 4.40087C5.65496 4.62035 5.77567 4.91029 5.77567 5.21756H6.93083C6.93083 4.60244 6.69056 4.02255 6.25275 3.58417C5.3783 2.71087 3.86216 2.71087 2.98828 3.58417L3.80382 4.40202C4.24278 3.96422 4.99941 3.96537 5.43606 4.40087Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouSearchIcon);
export default __webpack_public_path__ + "static/media/aou-search-icon.a827ef22a8d779f0c2b29beaf5f303f9.svg";
export { ForwardRef as ReactComponent };